// extracted by mini-css-extract-plugin
export var container = "BookList-module--container--2UwA1";
export var item = "BookList-module--item--TMStJ";
export var imageContainer = "BookList-module--imageContainer--13MRw";
export var inview = "BookList-module--inview--3CrDD";
export var image = "BookList-module--image--36a9T";
export var contentContainer = "BookList-module--contentContainer--34cxd";
export var title = "BookList-module--title--2xegN";
export var titleLink = "BookList-module--titleLink--1VU9F";
export var rating = "BookList-module--rating--3gZz6";
export var show = "BookList-module--show--xWJNB";
export var showFadeInDown = "BookList-module--show-fade-in-down--1i92u";
export var showFadeInUp = "BookList-module--show-fade-in-up--1K9Os";
export var hideFadeOut = "BookList-module--hide-fade-out--2Ctz0";